/**
 * ModuleDimensionInputs - Width/height inputs for custom module dimensions
 *
 * Two number inputs for specifying custom module dimensions in meters.
 */

import React from 'react';

interface ModuleDimensionInputsProps {
  width: number;
  height: number;
  onWidthChange: (width: number) => void;
  onHeightChange: (height: number) => void;
}

export function ModuleDimensionInputs({
  width,
  height,
  onWidthChange,
  onHeightChange,
}: ModuleDimensionInputsProps) {
  return (
    <div>
      <label className="block font-semibold text-gray-700 mb-1">Dimensions (m)</label>
      <div className="flex gap-2">
        <input
          type="number"
          step="0.1"
          min="0.5"
          max="3"
          value={width}
          onChange={(e) => onWidthChange(parseFloat(e.target.value))}
          className="w-full px-2 py-1 border border-gray-300 rounded text-xs"
          placeholder="Width"
        />
        <span className="self-center">×</span>
        <input
          type="number"
          step="0.1"
          min="0.5"
          max="3"
          value={height}
          onChange={(e) => onHeightChange(parseFloat(e.target.value))}
          className="w-full px-2 py-1 border border-gray-300 rounded text-xs"
          placeholder="Height"
        />
      </div>
    </div>
  );
}

export default ModuleDimensionInputs;
